import { combineReducers, createReducer } from '@reduxjs/toolkit';

import { TABLET_WIDTH } from 'constants/Layout';
import { SET_IS_MOBILE } from 'modules/app/actionTypes';

import isChatModalOpen from './isChatModalOpen';
import isCookieModalOpen from './isCookieModalOpen';

/**
 * @typedef {{
 *   isChatModalOpen: import('./isChatModalOpen').IsChatModalOpenState,
 *   isCookieModalOpen: import('./isCookieModalOpen').IsCookieModalOpenState,
 * }} UIState
 */

export default combineReducers({
  isChatModalOpen,
  isCookieModalOpen,
  isMobile: createReducer(window.innerWidth <= TABLET_WIDTH, (builder) => {
    builder.addCase(SET_IS_MOBILE, (_, { payload }) => payload);
  }),
});
